// extracted by mini-css-extract-plugin
module.exports = {"section":"talk-module--section--U2My_","icon":"talk-module--icon--1udr-","type":"talk-module--type--o-0I7","dialogButton":"talk-module--dialogButton--17ske"};